module.exports = __webpack_public_path__ + "static/media/6.781b0d6d.jpg";